import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDfJ9DKquPU98YhxktkBVZS78n7orNTF6Q",
  authDomain: "notui-ai.firebaseapp.com",
  projectId: "notui-ai",
  storageBucket: "notui-ai.appspot.com",
  messagingSenderId: "518927153262",
  appId: "1:518927153262:web:ca2df2812fa4f8d8e24e7f"
};

let app;
let auth;

try {
  // Initialize Firebase only once
  if (!app) {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    console.log('Firebase initialized successfully');
  }
} catch (error) {
  console.error('Firebase initialization error:', error);
}

export { auth, app }; 